module.exports = __webpack_public_path__ + "static/media/45.55042a91.png";